import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_COMMENTS,
    GET_ALL_REPLY_COMMENTS,
} from './commentTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_COMMENTS:
            return {
                ...state,
                all_comments: action.payload,
            }
        case GET_ALL_REPLY_COMMENTS:
            return {
                ...state,
                all_reply_comments: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
